import { render } from "./ModalAtualizarTarefa.vue?vue&type=template&id=13e9c00a"
import script from "./ModalAtualizarTarefa.vue?vue&type=script&lang=js"
export * from "./ModalAtualizarTarefa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__